import { render, staticRenderFns } from "./editGuide.vue?vue&type=template&id=c4d168c2&scoped=true"
import script from "./editGuide.vue?vue&type=script&lang=js"
export * from "./editGuide.vue?vue&type=script&lang=js"
import style0 from "./editGuide.vue?vue&type=style&index=0&id=c4d168c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d168c2",
  null
  
)

export default component.exports